import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiContext, BACKEND_CONFIG } from '@unicup-ticketing/injection-context';
import { Observable } from 'rxjs';
import { HasLinks } from '@unicup-ticketing/utils';
import { TicketResponse } from './ticket.service';

export interface TicketApiResponse extends TicketResponse, HasLinks {}

@Injectable({
  providedIn: 'root',
})
export class TicketApi {
  private readonly backendBaseUrl: string;

  private readonly http = inject(HttpClient);

  constructor() {
    const backendConfig = inject<ApiContext>(BACKEND_CONFIG);

    this.backendBaseUrl = backendConfig.baseUrl;
  }

  public getTicketByIdentifierAndDrawId(ticketId: string, drawId: string): Observable<TicketApiResponse> {
    return this.http.get<TicketApiResponse>(`${this.backendBaseUrl}/draws/${drawId}/tickets/${ticketId}`);
  }

  public getTicketByDrawIdAndRegistrationId(drawId: string, registrationId: string): Observable<TicketApiResponse> {
    return this.http.get<TicketApiResponse>(
      `${this.backendBaseUrl}/draws/${drawId}/registrations/${registrationId}/tickets`,
    );
  }

  public patchTicketPickedUpState(ticketId: string, newPickedUpState: boolean): Observable<TicketApiResponse> {
    return this.http.patch<TicketApiResponse>(`${this.backendBaseUrl}/tickets/${ticketId}`, {
      pickedUp: newPickedUpState,
    });
  }
}
